import React, { Component } from 'react';
import Echarts from "echarts";

class Market extends Component {

    componentDidMount() {
        const data = this.props.data.REV || {};
        let dataSource = Object.entries(data).map(x => ({ name: x[0], value: Number(x[1]) || 0 }));
        dataSource.sort((a, b) => a.value - b.value);
        this.setChart(dataSource);
        window.addEventListener('resize', () => {
            this.setChart(dataSource, true, true);
        });
    }

    componentWillReceiveProps(nextProps) {
        const data = nextProps.data.REV || {};
        let dataSource = Object.entries(data).map(x => ({ name: x[0], value: Number(x[1]) || 0 }));
        dataSource.sort((a, b) => a.value - b.value);
        this.setChart(dataSource, true);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => { });
    }

    setChart = (data, update, isOnResize) => {
        // 基于准备好的dom，初始化echarts实例
        var myChart = Echarts.init(document.getElementById('Market'));

        // 适应屏幕变化
        myChart.resize();
        if (isOnResize) {
            return
        }

        // 更新数据
        if (update) {
            myChart.setOption({
                series: [{
                    data,
                }]
            });
            return
        }

        const option = {
            color: ['#327AB7', '#4AC18E', '#D9534F', '#67A8E4', '#FFC61D'],
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            series: [{
                name: 'Cost',
                type: 'pie',
                radius: '55%',
                center: ['50%', '50%'],
                data: [],
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }]
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
    }

    render() {
        return (
            <div>
                <div className="total_style">Cost</div>
                <div id="Market" style={{ height: 400, width: '100%' }} />
            </div>
        );
    }
}

export default Market;


// WEBPACK FOOTER //
// ./src/components/BI/home/Market.js